import { faArrowRight } from '@fortawesome/pro-regular-svg-icons'
import { Box, Card, Flex, Text } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { DateTimePickerInput, Icon } from '@flecto/ui'

export function CoveragePeriod({
  startDate,
  endDate,
}: {
  startDate: string
  endDate: string
}) {
  const { t } = useTranslation('saas', { keyPrefix: 'insurances' })

  return (
    <Card>
      <Flex align='center' justify='space-between' mb='md'>
        <Box style={{ flex: 1 }}>
          <Text fw={500}>{t('insurances_details.coverage_period_title')}</Text>
          <Text c='dimmed' size='sm'>
            {t('insurances_details.coverage_period_description')}
          </Text>
        </Box>
      </Flex>

      <Flex gap='md' align='center' wrap='wrap'>
        <DateTimePickerInput value={startDate} disabled />
        <Icon icon={faArrowRight} size='sm' />
        <DateTimePickerInput value={endDate} disabled />
      </Flex>
    </Card>
  )
}
